import * as moment from 'moment';
import { ElementModel } from './element.model';
import { ExercisepartModel } from './exercisepart.model';

export class PreparationModel extends ExercisepartModel {

  // properties
  exercisename: string;
  isRateable = false;

  // relations
  elements: Array<ElementModel> = [];

  // client
  visible_at: any; // tslint:disable-line: variable-name

  deserialize(input: any): this {
    Object.assign(this, input);
    // elements
    let elements = null;
    if (this.elements !== null && this.elements !== undefined) {
      elements = [];
      this.elements.forEach((element: ElementModel) => {
        elements.push(new ElementModel().deserialize(element));
      });
    }
    this.elements = elements;
    return this;
  }

  public get visible(): boolean {
    return moment().isAfter(this.visible_at);
  }

  public getFirstElement(userType: string): ElementModel | null {
    if (this.elements !== null && this.elements.length > 0) {
      return this.elements.find((element: ElementModel) => {
        return (userType === 'observer' && element.permissions.indexOf('observer') !== -1) ||
        (userType === 'candidate' && element.permissions.indexOf('candidate') !== -1) ||
        userType === 'moderator';
      }) || null;
    }
    return null;
  }

}
